/* eslint-disable */
// Custom queries for UserData
export const userDataByUserId = /* GraphQL */ `
  query UserDataByUserId(
    $userId: String!
    $limit: Int
  ) {
    userDataByUserId(userId: $userId, limit: $limit) {
      items {
        id
        userId
        recipients
        shares
        capsules
        accountSettings
        legacyBook
        collections
        journal
        memoryCareSubjects
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;

// Lightweight re-fetch for merge-before-write: only retrieves legacyBook
// to avoid transferring the full UserData record on every book save.
export const legacyBookByUserId = /* GraphQL */ `
  query LegacyBookByUserId(
    $userId: String!
    $limit: Int
  ) {
    userDataByUserId(userId: $userId, limit: $limit) {
      items {
        id
        legacyBook
      }
      nextToken
    }
  }
`;
export const createUserData = /* GraphQL */ `
  mutation CreateUserData(
    $input: CreateUserDataInput!
  ) {
    createUserData(input: $input) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
    }
  }
`;
export const updateUserData = /* GraphQL */ `
  mutation UpdateUserData(
    $input: UpdateUserDataInput!
  ) {
    updateUserData(input: $input) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
    }
  }
`;
